import { Route, Switch } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { Header } from '../../__business/components/layouts/navigation/header/Index';
import { Bottom } from '../../__business/components/layouts/navigation/Bottom'
import { SuperCounter } from '../../__business/components/webTraffic/SuperCounters';
import Home from '../../__business/components/home/Index';
import ContactUs from '../../__business/components/contactus/Index';

export const WebRoute = () => {
    return (
        <Switch>
            {/* Landing Page */}
            <Route exact path="/" render={props=>(Render(Home, props))}/>
            <Route exact path="/contact-us" render={props=>(Render(ContactUs, props))}/>
            <Route exact path="/visit-website" render={props=>(Render(SuperCounter, props))}/>

            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}

const Render = (Component, props) => (
    <Box width="100%" height="100%">
        <Box width="100%" height="100%" display="flex" flexDirection="column">
            <Box minHeight={{mobile:'76px', desktop:'167px'}}>
                <Header/>
            </Box>
            <Box width="100%" height="100%" display="flex" flexDirection="column">
                <Component {...props} />
                <Bottom />
            </Box>
        </Box>
    </Box>
)